import sortBy from "lodash/sortBy";

export const getSortedPalletTypes = (palletTypes = []) => {
  if (!palletTypes) return [];
  return sortBy(palletTypes, pt => pt.sortOrder || 0);
};

export const getActiveSortedPalletTypes = (palletTypes = []) => {
  if (!palletTypes) return [];
  return getSortedPalletTypes(palletTypes.filter(pt => pt.isActive));
};
